<template>
    <f7-page name="snehove-spravodajstvo" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>Snehové spravodajstvo</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>
        <f7-subnavbar :inner="false">
            <f7-searchbar
                    search-container=".search-list"
                    search-in=".item-title"
                    placeholder="Hľadať..."
                    disable-button-text="Zrušiť"
                    :remove-diacritics="true"
                    :disable-button="!$theme.aurora"
            ></f7-searchbar>
        </f7-subnavbar>
        <template>

            <f7-list class="searchbar-not-found no-margin-top">
                <f7-list-item title="Nič nebolo nájdené..." subtitle="Skúste zmeniť parametre vyhľadávania..."></f7-list-item>
            </f7-list>
            <f7-list media-list class="search-list searchbar-found no-margin-top snowinfo">
                <f7-list-item v-for="(item, index) in this.snowData" :key="index"
                              :title="item.stredisko"
                              :after="item.vyskasnehu + ' cm'"
                              :subtitle="'Podmienky: ' + item.podmienky"
                              :text="'Prevádzka: ' + item.prevadzka"
                              :footer="'Dátum: ' + snehDtFormat(item.dt_ts)"
                              :no-chevron="true"
                >

                </f7-list-item>
            </f7-list>


          <f7-block>
            <p class="text-align-center">Zdroj údajov: <f7-link href="https://www.holidayinfo.sk/" external>www.holidayinfo.sk</f7-link></p>
          </f7-block>

        </template>
    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";


    export default {
        data: function () {
            return {
                snowData: [],
                isDataLoaded: false,
                lastUpdated: 0,
                tCheckInterval: null,
            };
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-pocasie');
            this.$f7.accordion.open('.shmu-i-pocasie');

        },
        destroy() {
            clearInterval(this.tCheckInterval);
        },
        methods: {
            onPageInit() {
                this.pageReload(null, true);
            },
            snehDtFormat(val) {
                return this.$moment.unix(val).format('DD.MM.YYYY');
            },
            pageReload(event, isInit) {
                const self = this;

                if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh
                    self.$f7.dialog.preloader('Načítavam...');

                    Axios.get(SHMUconf.API_BASE_URL + 'meteo/skiresortdata', {
                        crossDomain: true,
                        cache: false,
                    })
                        .then((response) => {
                            if (!response.data.error) {
                                self.snowData = response.data;
                                self.isDataLoaded = true;
                                self.lastUpdated = self.$moment().unix();
                                // clearInterval(this.tCheckInterval);
                                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60*1000); // overujem kazdu minutu
                            } else {
                              if (response.data.error[0].text) {
                                self.$f7.dialog.alert(response.data.error[0].text, 'Nastala chyba');
                              } else {
                                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne snehové spravodajstvo', 'Nastala chyba');
                              }
                            }

                            self.$f7.dialog.close();
                        }).catch((error) => {
                        self.$f7.dialog.close();
                        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                    });
                }


            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            }

        }

    };
</script>

<style lang="scss">

    .snowinfo {
        .item-after {
            color: var(--f7-color-primary);
            font-weight:bold;
        }
    }

</style>
